import React, { useState, useEffect } from 'react';
import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBBtn, MDBModalBody, MDBModalFooter, MDBIcon } from "mdb-react-ui-kit";
import uploadIcon from "../components/images/upload.svg";

const ImportExcelModal = ({
    isOpen,
    toggleModalClose,
    onDownloadSample,
    onImportFile,
    errorMessage
}) => {
    console.log("Error Message Received:", errorMessage);

    const [selectedFile, setSelectedFile] = useState(null);
    const [localErrorMessage, setLocalErrorMessage] = useState("");
    const [hasErrors, setHasErrors] = useState(false);


    useEffect(() => {
        if (isOpen) {
            setLocalErrorMessage(errorMessage || "");
            setHasErrors(!!errorMessage);
        }
    }, [errorMessage, isOpen]);


    useEffect(() => {
        if (!isOpen) {
            setSelectedFile(null);
            setLocalErrorMessage("");
            setHasErrors(false);
        }
    }, [isOpen]);

    const handleFileChange = (event) => {
        if (!event || !event.target || !event.target.files) return;
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setLocalErrorMessage("");
            setHasErrors(false);
        }
    };

    const handleUpload = async () => {
        if (selectedFile) {
            const result = await onImportFile(selectedFile);

            if (!result || (Array.isArray(result) && result.length > 0)) {
                setLocalErrorMessage(result?.join('\n'));
                setHasErrors(true);
                return;
            }

            toggleModalClose();
        }
    };




    const handleModalClose = () => {

        toggleModalClose();

    };

    return (
        <MDBModal open={isOpen} tabIndex="-1">
            <MDBModalDialog size="lg">
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>Importing Excel Sheet</MDBModalTitle>
                        <MDBBtn className="btn-close" color="none" onClick={handleModalClose}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>

                        <div className="d-flex align-items-center justify-content-between">
                            <h6>Please Download the sample data format</h6>
                            <MDBBtn onClick={onDownloadSample}>Download</MDBBtn>
                        </div>

                        <h6 className="mt-4">Upload the completed Excel sheet</h6>

                        {!selectedFile && (
                            <div className="uploadOuter mt-3">
                                <span className="dragBox2 upload-content">
                                    <span>
                                        <img src={uploadIcon} className="upload-img" alt="upload" />
                                    </span>
                                    <span>Drag and Drop to upload Files</span>
                                    <input
                                        type="file"
                                        id="uploadFile"
                                        className="upload__img"
                                        onChange={handleFileChange}

                                    />
                                </span>
                            </div>
                        )}

                        {selectedFile && (
                            <div className="border p-2 mt-2 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                                <span>{selectedFile.name}</span>
                                <MDBIcon fas icon="times" className="cursor-pointer me-2" onClick={() => setSelectedFile(null)} />
                            </div>
                        )}


                        {localErrorMessage && (
                            <div className="mt-3 p-2 border border-danger rounded bg-light">
                                <h6 className="text-danger">Validation Errors:</h6>
                                <ul>
                                    {localErrorMessage.split('\n').map((error, index) => (
                                        <li key={index} className="text-danger">{error}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                    </MDBModalBody>
                    <MDBModalFooter className="pb-2 pe-3">
                        <MDBBtn color="primary" onClick={handleUpload} disabled={!selectedFile || hasErrors}>
                            Upload
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
};

export default ImportExcelModal;
